import React, { useEffect, useState } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
const HeroSection = () => {
  const slides = [{
    id: 1,
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/qsdDED6hcK3bpaqpZuX5sy/WhatsApp_Image_2025-03-20_at_10.25.59_PM.jpg',
    title: 'Luxury Living Redefined',
    description: 'Modern apartments with premium retail spaces in Virar West'
  }, {
    id: 2,
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/iKY8MrH4rB6iDMRTiYMMsA/WhatsApp_Image_2025-03-15_at_7.40.52_PM.jpg',
    title: 'Thoughtfully Designed Spaces',
    description: 'Spacious 2 & 3 BHK apartments with modern amenities'
  }, {
    id: 3,
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/6vKDemLDxmQLyjfaZxqx8k/WhatsApp_Image_2025-03-20_at_10.26.00_PM.jpg',
    title: 'Premium Retail Opportunities',
    description: 'Prime commercial spaces in a thriving location'
  }, {
    id: 4,
    image: 'https://cdn.magicpatterns.com/uploads/nRoW81Yz4fSueuXAws29hU/Screenshot_2026-03-01_102437.png',
    title: 'Typical Floor Plan',
    description: 'Proposed Redevelopment of Viral & Shantivan Society, Virar West'
  }];
  const [currentSlide, setCurrentSlide] = useState(0);
  const nextSlide = () => {
    setCurrentSlide(prev => prev === slides.length - 1 ? 0 : prev + 1);
  };
  const prevSlide = () => {
    setCurrentSlide(prev => prev === 0 ? slides.length - 1 : prev - 1);
  };
  useEffect(() => {
    const interval = setInterval(() => {
      nextSlide();
    }, 6000);
    return () => clearInterval(interval);
  }, []);
  return <section id="home" className="relative h-screen w-full overflow-hidden" data-id="element-264">
      {/* Slider */}
      <div className="absolute inset-0" data-id="element-265">
        {slides.map((slide, index) => <div key={slide.id} className={`absolute inset-0 transition-opacity duration-1000 ease-in-out ${index === currentSlide ? 'opacity-100' : 'opacity-0'}`} data-id="element-266">
            <div className="absolute inset-0 bg-cover bg-center" style={{
          backgroundImage: `url(${slide.image})`
        }} data-id="element-267">
              <div className="absolute inset-0 bg-black opacity-40" data-id="element-268"></div>
            </div>
          </div>)}
      </div>
      {/* Content */}
      <div className="relative h-full flex items-center" data-id="element-269">
        <div className="container mx-auto px-4 lg:px-8" data-id="element-270">
          <div className="max-w-3xl" data-id="element-271">
            {slides.map((slide, index) => <div key={slide.id} className={`transition-all duration-700 ease-in-out transform ${index === currentSlide ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`} data-id="element-272">
                {index === currentSlide && <>
                    <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-4" data-id="element-273">
                      {slide.title}
                    </h1>
                    <p className="text-xl text-white mb-8" data-id="element-274">
                      {slide.description}
                    </p>
                    <div className="flex flex-wrap gap-4" data-id="element-275">
                      <a href="#projects" className="px-8 py-3 bg-blue-800 hover:bg-blue-900 text-white rounded font-medium transition-all" data-id="element-276">
                        Explore Our Projects
                      </a>
                      <a href="#contact" className="px-8 py-3 bg-transparent border-2 border-white hover:bg-white hover:text-blue-900 text-white rounded font-medium transition-all" data-id="element-277">
                        Schedule a Site Visit
                      </a>
                    </div>
                  </>}
              </div>)}
          </div>
        </div>
      </div>
      {/* Navigation Arrows */}
      <div className="absolute bottom-10 right-10 flex space-x-2" data-id="element-278">
        <button onClick={prevSlide} className="p-2 rounded-full bg-white/20 hover:bg-white/40 text-white transition-all" aria-label="Previous slide" data-id="element-279">
          <ChevronLeftIcon className="h-6 w-6" data-id="element-280" />
        </button>
        <button onClick={nextSlide} className="p-2 rounded-full bg-white/20 hover:bg-white/40 text-white transition-all" aria-label="Next slide" data-id="element-281">
          <ChevronRightIcon className="h-6 w-6" data-id="element-282" />
        </button>
      </div>
      {/* Dots */}
      <div className="absolute bottom-10 left-0 right-0" data-id="element-283">
        <div className="flex justify-center space-x-2" data-id="element-284">
          {slides.map((_, index) => <button key={index} onClick={() => setCurrentSlide(index)} className={`w-3 h-3 rounded-full transition-all ${index === currentSlide ? 'bg-white scale-110' : 'bg-white/50'}`} aria-label={`Go to slide ${index + 1}`} data-id="element-285" />)}
        </div>
      </div>
    </section>;
};
export default HeroSection;